import { Flex } from '@chakra-ui/react';
import { SharedFooter } from 'ui-components';
import { CreatorInfo } from '~/screens/ContentSharedScreen/ContentSharedScreen.types';
import { CreatorHeaderSharedScreen } from '~/screens/ContentSharedScreen/components/CreatorHeaderSharedScreen';

export interface LayoutContentSharedScreenProps {
  children?: React.ReactNode;
  creator: CreatorInfo;
}

export function LayoutContentSharedScreen({
  children,
  creator,
}: LayoutContentSharedScreenProps) {
  return (
    <Flex flexDirection={'column'} minHeight="100vh">
      <Flex
        paddingX={{ base: '0px', md: 'spacing-400' }}
        paddingY={{ base: '0px', md: 'spacing-300' }}
        direction="row"
        justify="center"
        align="center"
        backgroundColor={'neutral.100'}
        maxWidth="100%"
        flexGrow={2}
      >
        <Flex
          display="flex"
          maxW="800px"
          minWidth={{ base: '100%', md: '800px' }}
          flexDirection="column"
          alignItems="flexStart"
          backgroundColor={'white'}
          overflow={'hidden'}
          borderRadius="8px"
          boxShadow="0px 1px 4px 0px rgba(28,33,40,0.20)"
        >
          <CreatorHeaderSharedScreen creator={creator} />
          <Flex
            paddingX="spacing-300"
            paddingBottom="spacing-300"
            gap={{ base: 'spacing-300', md: '0' }}
            flexDirection={{ base: 'column', md: 'row' }}
          >
            {children}
          </Flex>
        </Flex>
      </Flex>
      <Flex alignItems="flex-start">
        <SharedFooter />
      </Flex>
    </Flex>
  );
}
